import type { State } from "xstate";
import type { FlightExchangeContext } from "../../types";

type FlightExchangeStateType = State<FlightExchangeContext>;
type FlightExchangeStateWithoutValue = Pick<FlightExchangeStateType, "context">;
type FlightExchangeStateWithAndWithoutValue =
  | FlightExchangeStateType
  | FlightExchangeStateWithoutValue;

export const getOriginalFlightItinerary = (
  state: FlightExchangeStateWithAndWithoutValue
) => state.context.exchangeContext.originalItinerary;
